import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from '@core/services/config.service';
import { appAnimations } from '@core/animations';
import {  Router } from '@angular/router';
import { AuthService } from '../../../../../services/auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { LocalStorageService } from 'ngx-webstorage';

export interface FormModel {
    captcha?: string;
}
@Component({
    selector   : 'app-login',
    templateUrl: './login.component.html',
    styleUrls  : ['./login.component.scss'],
    animations : appAnimations,
    providers: [ AuthService ]
})
export class AppLoginComponent implements OnInit
{
    public formModel: FormModel = {};

    loginForm: FormGroup;
    loginFormErrors: any;
    confirmDialogRef: MatDialogRef<AppAlertDialogComponent>;
    loading = false;
    constructor(
        private appConfig: AppConfigService,
        private formBuilder: FormBuilder,
        private router: Router,
        private _authService: AuthService,
        public dialog: MatDialog,
        private _storage: LocalStorageService

    )
    {

        this.appConfig.setSettings({
            layout: {

                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer    : {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.loginFormErrors = {
            email   : {},
            password: {},
            remember_me: {},
            captcha: {}
        };
    }

    ngOnInit()
    {
        this.loginForm = this.formBuilder.group({
            email   : ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            remember_me: [false],
            captcha: [null, Validators.required],
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });
    }



    onLoginFormValuesChanged()
    {
        for ( const field in this.loginFormErrors )
        {
            if ( !this.loginFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }
    public resolved(captchaResponse: string) {
        this.loginForm.get('captcha').setValue(captchaResponse);
    }

    onSubmit(){
        if (this.loginForm.valid) {
            this.loading = true;
            const data = this.loginForm.getRawValue();
            this._authService._login(data).subscribe((res: any) => {
                this._authService.currentUser = res;
                this._storage.store('currentUser', JSON.stringify(res.user));
                const token  = res.access_token;
                this._storage.store('token', token);
                this._authService.onUserChanged.next(res.user);
                this.loading = false;
                this.router.navigate(['/admin/propiedades/list']);
            },
            (err: any) => {
                this.alertError();
                this.loading = false;
            }
        );
        }
    }

    alertError()
    {
        this.confirmDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.alertMessage = 'Usuario y/o password incorrectos';

        this.confirmDialogRef.afterClosed().subscribe(result => {

            this.confirmDialogRef = null;
        });

    }
}
